import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=06090888&scoped=true&"
import script from "./Part.vue?vue&type=script&lang=js&"
export * from "./Part.vue?vue&type=script&lang=js&"
import style0 from "./Part.vue?vue&type=style&index=0&id=06090888&lang=less&scoped=true&"
import style1 from "./Part.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06090888",
  null
  
)

export default component.exports